import { BoundingRect } from 'app/agriculture/routes/SetDefaultMapView/BoundingRect';
import './RotatableBoundingRect.scss';

interface RotatableBoundingRectProps {
    rotation: 0 | 90 | 180 | 270;
}

export function RotatableBoundingRect({ rotation }: RotatableBoundingRectProps) {
    return (
        <div className="RotatableBoundingRect" style={{ '--rotation': rotation }}>
            <BoundingRect />
        </div>
    );
}
